<template>
  <div>
    <Card
      title="Add Artist"
    >
      <template v-slot:button>
        <Button  @clicked="goBack" variant="default" label="Cancel" />
      </template>
      <template v-slot:body>
        <form-wizard ref="formWizard" shape="tab" @on-complete="onCompleteSave" color="#3498db" title="" subtitle="">
          <tab-content title="Profile Details" :before-change="()=>validateStep('step1')">
            <Step1 ref="step1" @on-validate="mergePartialModels"></Step1>
          </tab-content>
          <tab-content title="Bank Info"  :before-change="()=>validateStep('step2')">
            <Step2 ref="step2" @on-validate="mergePartialModels"></Step2>
          </tab-content>
          <template slot="footer" slot-scope="props">
            <div class=wizard-footer-left>
              <wizard-button  v-if="props.activeTabIndex > 0" :style="props.fillButtonStyle" @click.native="props.prevTab()">Previous</wizard-button>
            </div>
            <div class="wizard-footer-right">
              <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right" :style="props.fillButtonStyle">Next</wizard-button>
              <wizard-button v-if="props.isLastStep" @click.native="isDraft = false;props.nextTab()" class="wizard-footer-right finish-button" :style="props.fillButtonStyle">Publish</wizard-button>
              <wizard-button v-if="props.isLastStep" @click.native="isDraft = true;props.nextTab()" class="wizard-footer-right draft-button" :style="props.fillButtonStyle">Save as Draft</wizard-button>

            </div>
          </template>
        </form-wizard>
      </template>
    </Card>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';
import Step1 from './Step1';
import Step2 from './Step2';
import Card from '@/components/Layout/Card.vue';
import { Button } from '@/components/Layout/Form';

export default {
  name: 'AddArtistPage',
  data() {
    return {
      finalModel: {},
      isDraft: false,
      isError: false,
    };
  },
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    // ...mapGetters('ArtistModule', ['getArtist']),
  },
  methods: {
    ...mapActions('ArtistModule', ['requestAddArtist']),
    goBack(){
      this.$router.push('/artists')
    },
    validateStep(name) {
      const refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model);
      }
    },
    async onCompleteSave() {
      const dataArtist = new FormData();
      dataArtist.append('name', this.finalModel.fullname);
      dataArtist.append('email', this.finalModel.email);
      dataArtist.append('bio', this.finalModel.bio);
      dataArtist.append('dob', this.finalModel.dob);
      dataArtist.append('password', this.finalModel.password);
      dataArtist.append('status', !this.isDraft ? 1 : 3);
      dataArtist.append('language', this.finalModel.language);
      if (this.finalModel.bank !== '' && this.finalModel.account_name !== '' && this.finalModel.account_number !== '' && this.finalModel.swift_code !== '') {
        dataArtist.append('bank_account[bank]', this.finalModel.bank);
        dataArtist.append('bank_account[account_number]', this.finalModel.account_number);
        dataArtist.append('bank_account[account_name]', this.finalModel.account_name);
        dataArtist.append('bank_account[swift_code]', this.finalModel.swift_code);
      }
      if (!!this.finalModel.avatar && this.finalModel.avatar != '') {
        const resultimage = await axios({
          method: 'get',
          url: this.finalModel.avatar,
          responseType: 'blob',
        }).then(this.processFileBlob);
        dataArtist.append('avatar', resultimage);
      }
      if (this.finalModel.fileAgreement) {
        const ext = this.getExt(this.finalModel.fileAgreementName);
        if (ext != 'pdf') {
          const resultFileAgreement = await axios({
            method: 'get',
            url: this.finalModel.fileAgreement,
            responseType: 'blob',
          }).then(this.processFileBlob);
          dataArtist.append('file_agreement', resultFileAgreement);
          dataArtist.append('file_agreement_type', 'image');
        } else {
          dataArtist.append('file_agreement', this.finalModel.fileAgreement);
          dataArtist.append('file_agreement_type', 'pdf');
        }
      }

      await this.requestAddArtist(dataArtist);
      if (this.getStatus != 200 && this.getErrorCode == 'error-add-artist-admin') {
        this.isError = true;
        this.$swal('Error', this.getMessage, 'error');
      } else {
        this.isError = false;
        this.resetModelState();
        this.$refs.step1.$v.$reset();
        this.$refs.step2.$v.$reset();
        this.$refs.formWizard.reset();
        if (this.isDraft) {
          this.$router.push({ name: 'DraftArtistPage' });
        } else {
          this.$router.push({ name: 'Artists' });
        }
      }
    },
    resetModelState() {
      this.$refs.step1.$data.fullname = '';
      this.$refs.step1.$data.email = '';
      this.$refs.step1.$data.emailErrorMessage = '';
      this.$refs.step1.$data.imageErrorMessage = '';
      this.$refs.step1.$data.isFileLarge = false;
      this.$refs.step1.$data.bio = '';
      this.$refs.step1.$data.dob = '';
      this.$refs.step1.$data.password = '';
      this.$refs.step1.$data.showPassword = false;
      this.$refs.step1.$data.fileAgreement = null;
      this.$refs.step1.$data.fileAgreementName = null;
      this.$refs.step1.changeImage();

      this.$refs.step2.$data.bank = '';
      this.$refs.step2.$data.account_name = '';
      this.$refs.step2.$data.account_number = '';
      this.$refs.step2.$data.swift_code = '';
    },
    processFileBlob(response) {
      const file = new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(response.data);
        reader.onloadend = () => {
          resolve(reader.result);
        };
      });
      return file.then(data => data);
    },
    getExt(name) {
      const fileInfo = name.split('.');
      return fileInfo[fileInfo.length - 1];
    },
  },
  components: { Step1, Step2, Card, Button, },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ArtistContent/AddArtist.vue